import { PrivateInterceptor } from "../../../interceptors/PrivateInterceptor"
import { PublicInterceptor } from "../../../interceptors/PublicInterceptor"

export const getCorreos = async (IdListaCorreo) => {
   const result = await PrivateInterceptor(`Base/IT/ListaCorreo/${IdListaCorreo}`)
   return result
}

export const getListaCorreoToken = async(Token) => {
    const result = await PublicInterceptor(`Base/IT/ListaCorreo`, 'GET', {}, Token)
    return result;
}